export const LOCKED_CASHFLOW_MODULE_ID = "cashflow-module";
export const BASE_MODULE_ID = "receivables-module";
export const ORGANISATION_MODULE_ID = "organisation-module";
export const DEFAULT_RAIL_SECTION = "modules";
export const ADDONS_MODULE_QUERY_KEYS = ["module", "module-name"];

export const CASHFLOW_PLAN_ORDER = [
  "cashflow-trial",
  "cashflow-compact",
  "cashflow-core",
  "cashflow-complete",
];
